// extracted by mini-css-extract-plugin
export default {"TrainingView":"v45pZD1T8ZDzCOKNrz_A"};